import { analyzePatterns } from "./patternEngine";

export const buildSmartPrompt = (trades, userName) => {
  const p = analyzePatterns(trades);
  if (!p) return null;

  const name = userName?.split(' ')[0] || 'Trader';

  return `
Tu ek expert trading psychologist aur coach hai.
Trader ka naam ${name} hai.
Usse seedha, specific, actionable advice do.

=== ${name.toUpperCase()} KA REAL TRADING DATA ===

OVERALL PERFORMANCE:
- Total P&L: ₹${p.totalPnl}
- Win Rate: ${p.winRate}%
- Total Trades: ${p.totalTrades} (${p.wins} wins, ${p.losses} losses)
- Average Win: +₹${p.avgWin}
- Average Loss: -₹${Math.abs(p.avgLoss)}
- Best Trade: +₹${p.bestTrade}
- Worst Trade: ₹${p.worstTrade}

TIME PATTERNS:
${p.worstHour ? `- Worst time: ${p.worstHour.label} → ₹${p.worstHour.pnl} total loss, ${p.worstHour.count} trades` : ''}
${p.bestHour ? `- Best time: ${p.bestHour.label} → ₹${p.bestHour.pnl} total profit` : ''}

DAY PATTERNS:
${p.worstDay ? `- Worst day: ${p.worstDay.day} → avg ₹${p.worstDay.avgPnl} per trade` : ''}
${p.bestDay ? `- Best day: ${p.bestDay.day} → avg ₹${p.bestDay.avgPnl} per trade` : ''}

EMOTION ANALYSIS:
${p.emotionArr.map(e =>
  `- ${e.emotion}: ${e.count} trades, ₹${e.pnl} total, ${e.winRate}% win rate`
).join('\n')}

SETUP PERFORMANCE:
${p.setupArr.map(s =>
  `- ${s.setup}: ${s.count} trades, ${s.winRate}% win rate, ₹${s.pnl} total`
).join('\n')}

SYMBOL PERFORMANCE:
${p.symbolArr.map(s =>
  `- ${s.symbol}: ${s.count} trades, ₹${s.pnl} P&L, ${s.winRate}% win rate`
).join('\n')}

PSYCHOLOGICAL ISSUES:
- Consecutive losses max: ${p.maxConsecLoss}
- Revenge trades: ${p.revengeCount}
${p.fomoStats ? `- FOMO total loss: ₹${p.fomoStats.pnl} (${p.fomoStats.count} trades)` : ''}
${p.greedyStats ? `- Greedy total loss: ₹${p.greedyStats.pnl} (${p.greedyStats.count} trades)` : ''}

STRENGTHS:
${p.strengths.map(s => `✓ ${s}`).join('\n')}

WEAKNESSES:
${p.weaknesses.map(w => `✗ ${w}`).join('\n')}

=== INSTRUCTIONS ===

${name} ko STRICT COACH ki tarah advice do.
Format EXACTLY yeh use karo:

**${name} bhai, tera trading data dekha —**
[1-2 line honest summary]

**💪 Kya achha kar raha hai:**
[Specific strengths with numbers]

**⚠️ Sabse badi problem:**
[Most critical weakness with exact numbers]

**🎯 Kal se 3 rules follow karna hai:**
1. [Specific rule with exact time/emotion/symbol]
2. [Specific rule with exact number]
3. [Specific rule based on pattern]

**📈 Agar yeh 3 rules follow kiye toh:**
[Expected improvement with numbers]

**Ek line motivation:**
[Short, powerful, personal]

Rules:
- ZERO generic advice
- Har point mein exact number use karo
- Hinglish mein bolo (Hindi + English mix)
- Max 300 words
- Emojis use karo but kam
`;
};

export const buildPostTradePrompt = (trade, recentTrades, userName) => {
  const name = userName?.split(' ')[0] || 'Trader';
  const lastPnl = recentTrades.slice(-3).map(t => t.pnl);
  const isLosing = lastPnl.filter(p => p < 0).length >= 2;

  return `
Tu trading coach hai. ${name} ne abhi ek trade kiya.

Trade details:
- Symbol: ${trade.symbol || trade.stock}
- Type: ${trade.type}
- P&L: ₹${trade.pnl}
- Emotion: ${trade.emotion}
- Setup: ${trade.setup}

Last 3 trades P&L: ${lastPnl.join(', ')}
Consecutive losses: ${isLosing ? 'Haan - 2+ losses' : 'Nahi'}

Short 2-3 line feedback do Hinglish mein:
${trade.pnl < 0 && isLosing
  ? 'Warning do - ab aur trading mat karo aaj'
  : trade.pnl > 0
    ? 'Appreciate karo but overconfidence warn karo'
    : 'Neutral feedback do'
}
`;
};
